import { ExternalLink, Wrench } from "lucide-react";
import { Logo } from "./Logo";
import { Countdown } from "./Countdown";
import { VideoBackdrop } from "./VideoBackdrop";
import { useContent } from "@/context/ContentContext";

export function MaintenancePage() {
  const { content } = useContent();
  const m = content.maintenance;
  const hero = { countdown_enabled: !!m.until, countdown_date: m.until, countdown_title: m.countdown_title || "Voltamos em", countdown_done_text: m.countdown_done_text || "Estamos quase de volta." };
  return (
    <div className="grain relative flex min-h-screen flex-col items-center justify-center overflow-hidden bg-eden-bg px-6 text-center" data-testid="maintenance-page">
      {content.media?.hero_image_url ? <img src={content.media.hero_image_url} alt="" className="absolute inset-0 h-full w-full object-cover opacity-20" aria-hidden="true" /> : <VideoBackdrop opacity={0.3} />}
      <div className="absolute inset-0 bg-gradient-to-t from-eden-bg via-eden-bg/80 to-eden-bg/40" aria-hidden="true" />
      <div className="relative flex max-w-2xl flex-col items-center">
        <Logo url={content.media?.logo_url} className="h-12" textClass="text-2xl" />
        <p className="eyebrow mt-12 inline-flex items-center gap-2 animate-fade-up"><Wrench size={14} aria-hidden="true" /> {m.eyebrow || "Em manutenção"}</p>
        <h1 className="mt-6 text-4xl font-extrabold leading-[1.05] tracking-tight text-eden-text animate-fade-up [animation-delay:80ms] sm:text-5xl lg:text-6xl" data-testid="maintenance-title">{m.title}</h1>
        {m.text && <p className="mt-6 max-w-xl text-base leading-relaxed text-eden-secondary animate-fade-up [animation-delay:160ms] sm:text-lg" data-testid="maintenance-text">{m.text}</p>}
        <div className="flex flex-col items-center">
          <Countdown hero={hero} />
        </div>
        {m.show_discord && content.links?.discord_invite && (
          <a href={content.links.discord_invite} target="_blank" rel="noopener noreferrer" className="btn-secondary mt-10 animate-fade-up [animation-delay:280ms]" data-testid="maintenance-discord">
            {m.discord_label || "Acompanha no Discord"} <ExternalLink size={16} aria-hidden="true" />
          </a>
        )}
      </div>
    </div>
  );
}
